window.scrollshadow = (function() {
  'use strict';

  var wrapper = document.querySelector('.js-scrollshadow'),
      scrollContent = document.querySelectorAll('.js-scroll-content');

      scrollContent.forEach(function(elem) {
        elem.addEventListener('scroll', function() {
          var shadowLeft = elem.querySelector('.shadow--left'),
          shadowRight = elem.querySelector('.shadow--right'),
          contentScrollWidth = elem.scrollWidth - wrapper.offsetWidth,
          currentScroll = elem.scrollLeft / contentScrollWidth;

          if (elem.querySelector('.sticky')) {
            shadowLeft.classList.add('rt');
          }

          shadowLeft.style.opacity = currentScroll;
          shadowRight.style.opacity = 1 - currentScroll;
        });
    });
})();

